// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import messagesEn from "../lang/messages-en.json";
import messagesFr from "../lang/messages-fr.json";
import { createI18n } from "vue-i18n";

const messages = {
  en: { ...messagesEn },
  fr: { ...messagesFr },
  "fr-FR": { ...messagesFr },
  "en-US": { ...messagesEn },
};

let i18n: any = null;

export function useI18n() {
  if (i18n === null) {
    i18n = createI18n({
      globalInjection: true,
      fallbackLocale: "en",
      locale: Office.context.displayLanguage,
      messages,
    });
  }
  return i18n;
}

const translate = (key: string) => {
  if (!key) {
    return "";
  }

  return i18n.global.t(key);
};

export { translate };
